import Logo from "assets/logo-light.svg"
import "./index.scss"
import { FiBell, FiSearch, FiShoppingCart, FiUser } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "App";
import { useSelector } from "react-redux";
import { geTotalCartAmount } from "slices/cart";


interface Props {
}


export function Nav(props: Props) {
    const totalAmount = useSelector(geTotalCartAmount)
    const { handleCloseCart } = useContext(AppContext)

    return (
        <div className="main-bg">
            <div className="max-width p-x nav mob-py-07">
                <Link to='/' className="nav-logo desktop">
                    <img src={Logo} alt="" />
                </Link>

                <div className="nav-search mob-mx-0">
                    <input type="text" className="nav-search__input" placeholder="Search for products (e.g. fish, apple, oil)" />
                    <i className="nav-search__icon">
                        <FiSearch />
                    </i>
                </div>
                <div className="nav-right desktop">
                    <i className="icon">
                        <Link to='/'>
                            <FiBell />
                        </Link>
                    </i>
                    <i className="icon" onClick={handleCloseCart}>
                        <a href="#!">
                            <span className="float-top-right">
                                {totalAmount}
                            </span>
                            <FiShoppingCart />
                        </a>
                    </i>
                    <i className="icon">
                        <Link to='/dashboard'>
                            <FiUser />
                        </Link>
                    </i>
                </div>
            </div>
        </div>
    )
}
